import { render, staticRenderFns } from "./Epassi.vue?vue&type=template&id=3b4092b9"
import script from "./Epassi.vue?vue&type=script&lang=js"
export * from "./Epassi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports